import './fixedR.scss';

// import {
// 	fixedRHandler
// } from './fixedRHandler';

// export default (() => {
// 	// $(document).ready(function () {
// 	// 	const container = document.querySelector('body');
// 	// 	const imgs = document.querySelectorAll('.fixed-R');
// 	// 	fixedRHandler(imgs, container);
// 	// });
// })();
